// extracted by mini-css-extract-plugin
export default {"sib-status":"QrRZ3dAHqnqmvAPTC0QA","status__indicator":"pqy05nOUMkGybG2IXLML","status__label":"NIISp87uD4uI6IWreLec"};